import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=a16efa78&scoped=true"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"
import style0 from "./Carrinho.vue?vue&type=style&index=0&id=a16efa78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16efa78",
  null
  
)

export default component.exports